import mapping from "../mappings/componentsMapping";

function actionFactory(React, actionConfig) {
  return React.createElement(mapping[actionConfig.type], actionConfig.props)
}


export default actionFactory
